/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectors as groupSelectors } from '../../redux/ducks/group';

import GroupTitleTemplate from './GroupTitle.template';
import AppUtils from '../../../utilities/AppUtils';

function mapStateToProps(state) {
  return {
    getGroup: (groupId) => groupSelectors.getGroup(state, groupId),
  };
}

const GroupTitle = (props) => {
  const group = props.getGroup(props.groupId);

  return (
    <GroupTitleTemplate
      group={group}
      withOrganizationName={props.withOrganizationName}
      size={props.size}
      color={AppUtils.cssColor(group.theme.base_rgba)}
    />
  );
};
GroupTitle.propTypes = {
  getGroup: PropTypes.func,
  groupId: PropTypes.number,
  size: PropTypes.string,
  withOrganizationName: PropTypes.bool,
};

export default connect(mapStateToProps)(GroupTitle);
